<template>
    <div class="row mtn-30">
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">{{ $t('referans') }}</h5>
                <div class="fun-fact__count counter">
                    <ICountUp
                        :endVal="26523"
                    />
                    <span>+</span>
                </div>
                <span class="fun-fact__text">{{ $t('mutlumusteriler') }}</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">{{ $t('deneyim') }} <br> </h5>
                <div class="fun-fact__count counter">
                    <ICountUp
                        :endVal="27"
                    />
                    <span>{{ $t('yil') }}+</span>
                </div>
                <span class="fun-fact__text">{{ $t('bilgibirikimtecrube') }}</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">{{ $t('uzmanekip') }}</h5>
                <div class="fun-fact__count counter">
                    <ICountUp
                        :endVal="40"
                    />
                    <span>+</span>
                </div>
                <span class="fun-fact__text">{{ $t('isininuzmanlari') }}</span>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
            <div class="fun-fact--one mt-30 text-center">
                <h5 class="fun-fact__title">{{ $t('proje') }}</h5>
                <div class="fun-fact__count counter">
                    <ICountUp
                        :endVal="1607"
                    />
                    <span>+</span>
                </div>
                <!-- <span class="fun-fact__text">Tecrübe</span> -->
            </div>
        </div>
    </div>
</template>

<script>
    import ICountUp from 'vue-countup-v2';
    export default {
        name: 'FunFactOne',
        components: {
            ICountUp
        },
        data() {
            return {
                delay: 100
            };
        }
    };
</script>